(() => {
  const root = document.querySelector('voler-custom-catalog [data-new2027]');
  if (!root) return;
  const panels = [...root.querySelectorAll('[data-new-panel]')];
  const tabs = [...root.querySelectorAll('[data-new-select]')];
  const mountain = root.querySelector('[data-new-panel="mountain"]');
  const article = root.closest('.garment');
  if (!mountain || !article || panels.length < 2 || panels.length !== tabs.length ||
      tabs.some(tab => panels.filter(panel => panel.dataset.newPanel === tab.dataset.newSelect).length !== 1)) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const reference = mountain.querySelector('.catalog-highlight-tour');
  const alignOverlays = () => {
    if (!reference.offsetWidth) return;
    const sourceStyle = getComputedStyle(reference);
    panels.filter(panel => panel !== mountain && !panel.hidden).forEach(panel => {
      const target = panel.querySelector('.catalog-highlight-tour');
      if (!target) return;
      target.style.gridTemplateRows = sourceStyle.gridTemplateRows;
      for (const selector of ['.catalog-highlight-intro', '.vft__visual', '.vft__panels']) {
        const source = reference.querySelector(selector);
        const destination = target.querySelector(selector);
        destination.style.height = source.getBoundingClientRect().height + 'px';
        destination.style.flexShrink = '0';
      }
      const originalTitle = reference.querySelector('.catalog-highlight-intro h3');
      const title = target.querySelector('.catalog-highlight-intro h3');
      const titleStyle = getComputedStyle(originalTitle);
      title.style.fontSize = titleStyle.fontSize;
      title.style.lineHeight = titleStyle.lineHeight;
      title.style.height = originalTitle.getBoundingClientRect().height + 'px';
      title.style.whiteSpace = 'nowrap';
      if (title.scrollWidth > title.clientWidth) {
        title.style.fontSize = (parseFloat(titleStyle.fontSize) * title.clientWidth / title.scrollWidth) + 'px';
      }
    });
  };
  new ResizeObserver(alignOverlays).observe(reference);
  document.fonts.ready.then(alignOverlays);
  const select = (index, { focus = false, reveal = false } = {}) => {
    const selected = panels.find(panel => panel.dataset.newPanel === tabs[index].dataset.newSelect);
    mountain.classList.toggle('is-inactive', selected !== mountain);
    mountain.inert = selected !== mountain;
    mountain.setAttribute('aria-hidden', String(selected !== mountain));
    panels.filter(panel => panel !== mountain).forEach(panel => { panel.hidden = panel !== selected; });
    alignOverlays();
    article.setAttribute('aria-labelledby', selected.querySelector('.catalog-highlight-intro h3').id);
    tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
    if (focus) tabs[index].focus({ preventScroll: true });
    if (reveal && matchMedia('(max-width:699px)').matches && root.getBoundingClientRect().top < 0) {
      root.scrollIntoView({ block: 'start', behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    }
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index, { reveal: true }));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      select(next, { focus: true });
      tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    });
  });
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-new-guide]');
    if (!button || !root.contains(button)) return;
    const catalog = root.closest('voler-custom-catalog');
    const card = [...catalog.querySelectorAll('.garment')].find(card => card.dataset.id === button.dataset.newGuide);
    const trigger = card?.querySelector('.catalog-open-guide');
    const drawer = catalog.querySelector('.catalog-product-drawer');
    if (!trigger || !drawer || !catalog.hasAttribute('data-drawer-ready')) return;
    drawer.addEventListener('dialog:after-hide', () => {
      if (button.isConnected && !button.closest('[hidden]')) button.focus({ preventScroll: true });
    }, { once: true });
    trigger.click();
  });
  const rail = root.querySelector('.catalog-new2027-selectors');
  const hint = root.querySelector('[data-new-scroll-hint]');
  root.dataset.newMore = String(tabs.length > 2);
  const controls = root.querySelector('[data-new-scroll-controls]');
  const previous = controls?.querySelector('[data-new-scroll="previous"]');
  const next = controls?.querySelector('[data-new-scroll="next"]');
  const updateScrollHint = () => {
    if (!rail || !hint) return;
    const overflowing = rail.scrollWidth > rail.clientWidth + 1;
    const atStart = rail.scrollLeft <= 1;
    const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
    if (controls) controls.hidden = !overflowing;
    if (previous) previous.disabled = atStart;
    if (next) next.disabled = atEnd;
    const show = matchMedia('(max-width:699px)').matches && overflowing;
    hint.hidden = !show;
    const arrow = hint.querySelector('[data-new-scroll-direction]');
    if (arrow) {
      const atStart = rail.scrollLeft <= 1;
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      arrow.textContent = atStart ? '→' : atEnd ? '←' : '↔';
    }
    if (show) rail.setAttribute('aria-describedby', hint.id);
    else rail.removeAttribute('aria-describedby');
  };
  controls?.addEventListener('click', event => {
    const button = event.target.closest('[data-new-scroll]');
    if (!rail || !button || button.disabled || !controls.contains(button)) return;
    const step = tabs.length > 1 ? tabs[1].offsetLeft - tabs[0].offsetLeft : rail.clientWidth;
    rail.scrollBy({ left: button.dataset.newScroll === 'next' ? step : -step, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  });
  if (rail) { new ResizeObserver(updateScrollHint).observe(rail); rail.addEventListener('scroll', updateScrollHint, { passive: true }); }
  const initialIndex = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
  select(initialIndex >= 0 ? initialIndex : 0);
  root.dataset.newReady = '';
  updateScrollHint();
})();
